module.exports = __webpack_public_path__ + "img/file-text.c533f1da.svg";